import { API_URLS } from "src/api/api-urls";

export enum PlatformsEnum {
  FORBES = "forbes",
  YOUTUBE = "youtube",
  TWITTER = "twitter",
  MEDIUM = "medium",
  MERCURY_NEWS = "mercury_news",
  QUARTZ = "quartz",
  NYC_TIMES = "nyc_times",
}

export const PLATFORMS = {
  [PlatformsEnum.FORBES]: {
    label: PlatformsEnum.FORBES,
    main: API_URLS.main.FORBES,
    custom: API_URLS.custom.FORBES,
  },
  [PlatformsEnum.YOUTUBE]: {
    label: PlatformsEnum.YOUTUBE,
    main: API_URLS.main.YOUTUBE,
    custom: API_URLS.custom.YOUTUBE,
  },
  [PlatformsEnum.TWITTER]: {
    label: PlatformsEnum.TWITTER,
    main: API_URLS.main.TWITTER,
    custom: API_URLS.custom.TWITTER,
  },
  [PlatformsEnum.MEDIUM]: {
    label: PlatformsEnum.MEDIUM,
    main: API_URLS.main.MEDIUM,
    custom: API_URLS.custom.MEDIUM,
  },
  [PlatformsEnum.QUARTZ]: {
    label: PlatformsEnum.QUARTZ,
    main: API_URLS.main.QUARTZ,
    custom: API_URLS.custom.QUARTZ,
  },
  [PlatformsEnum.NYC_TIMES]: {
    label: PlatformsEnum.NYC_TIMES,
    main: API_URLS.main.NYC_TIMES,
    custom: API_URLS.custom.NYC_TIMES,
  },
  [PlatformsEnum.MERCURY_NEWS]: {
    label: PlatformsEnum.MERCURY_NEWS,
    main: API_URLS.main.MERCURY_NEWS,
    custom: API_URLS.custom.MERCURY_NEWS,
  },
};
